module.exports = __webpack_public_path__ + "static/media/art8.ee417805.jpg";